export default "__VITE_ASSET__CjUT968q__"